/**
 * Labstep
 */

import { PostFilter } from 'labstep-web/services/postFilter';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';

export const PostFilterResourceLocation = new PostFilter(
  [['guid', PostFilterComparison.eq]],
  'resourceLocation',
);

export const getPostFilterResourceLocation = (path?: string) =>
  new PostFilter(
    [['guid', PostFilterComparison.eq]],
    path ? path : 'resourceLocation',
  );
